<template>
  <main>
    <InputFilter class="pt-10" :pagination="pagination" />
    <!-- <illustrations /> -->
    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col sm="10" class="mx-auto py-0">
            <v-row>
              <v-col sm="3" class="camp-type py-0">
                <v-select
                  :items="camp_types"
                  item-text="name"
                  item-value="id"
                  label="Camp Types"
                  :append-icon="filter.type ? 'mdi-close' : ''"
                  @click:append="clearSearchData('type')"
                  filled
                  dense
                  v-model="filter.type"
                  @change="filterCamp"
                ></v-select>
              </v-col>
              <v-col sm="3" class="location py-0">
                <v-select
                  :items="camp_locations"
                  item-text="name"
                  item-value="id"
                  label="Location"
                  filled
                  :append-icon="filter.location ? 'mdi-close' : ''"
                  @click:append="clearSearchData('location')"
                  dense
                  v-model="filter.location"
                  @change="filterLocation"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3" class="py-0 month">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="filter.date"
                      label="Date"
                      filled
                      dense
                      persistent-hint
                      :append-icon="filter.date ? 'mdi-close' : ''"
                      @click:append="clearSearchData('date')"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.date"
                    no-title
                    @input="filterDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="3" class="gender py-0">
                <v-select
                  :items="availableArray"
                  item-text="name"
                  item-value="name"
                  label="Availability"
                  filled
                  dense
                  v-model="filter.available"
                  @change="filterAvailability"
                  :append-icon="filter.available ? 'mdi-close' : ''"
                  @click:append="clearSearchData('available')"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-container>
      <v-toolbar flat class="main-header mb-6 px-0">
        <v-toolbar-title class="main-header__title">
          <h1>Review Daily Figures</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <download-excel :data="dailyFigures" :fields="json_fields">
            <v-btn outlined color="red" large class="mt-3"
              ><v-icon class="mr-3">mdi-cloud-download</v-icon>Export</v-btn
            >
          </download-excel>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :loading="loadingDataTable"
        :items="dailyFigures"
        :mobile-breakpoint="0"
        :items-per-page="20"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item }">
          <tr class="table__row">
            <td class="table__cell text-center green-color">
              {{ item ? item.total_paid : "---" }}
            </td>
            <td class="table__cell text-center red-color">
              {{ item ? item.total_unpaid : "---" }}
            </td>
            <td class="table__cell name text-center">
              <strong>{{ item ? item.total_refund : "---" }}</strong>
            </td>
            <td class="table__cell text-center black-color">
              <strong>{{ item ? item.name : "---" }}</strong>
            </td>
            <td class="table__cell text-center">
              {{ item.start_date.date | moment("Do,MMM' YYYY") }}
            </td>
            <td class="table__cell text-center">
              {{ item.end_date.date | moment("Do,MMM' YYYY") }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="dailyFigures.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      dailyFigures: [],
      headers: [],
      loadingDataTable: false,
      pagination: {},
      camp_types: [],
      camp_locations: [],

      menu1: false,
      dateFormatted: "",
      availableArray: [{ name: "all" }, { name: "yes" }, { name: "no" }],
      filter: {
        type: "",
        location: "",
        date: "",
        available: ""
      },
      json_fields: {
        "Complete name": "name",
        "Start Date": {
          field: "start_date.date"
        },
        "End Date": {
          field: "end_date.date"
        },
        Paid: "total_paid",
        Unpaid: "total_unpaid",
        Refund: "total_refund"
      },
      queries: {}
    };
  },
  components: {
    // Illustrations: () => import("./Illustrations"),
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  created() {
    this.createTableHeaders();
    this.indexTypes();
    this.indexLocations();
    // this.indexStatistics();
  },
  methods: {
    indexReservation(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: `reports/camp-statistics-per-day`, query })
        .then(res => {
          const { data, meta } = res.data;
          this.dailyFigures = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexTypes() {
      IndexData({ reqName: `/camp-types` })
        .then(res => {
          const { data } = res.data;
          this.camp_types = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexLocations() {
      IndexData({ reqName: `/locations` })
        .then(res => {
          const { data } = res.data;
          this.camp_locations = data;
        })
        .catch(() => {})
        .finally(() => {});
    },

    filterCamp(type) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, type, page: 1 } });
    },
    filterLocation(location) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, location, page: 1 } });
    },
    filterAvailability(available) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, available, page: 1 } });
    },
    filterDate(date) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, date, page: 1 } });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filter[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
    createTableHeaders() {
      const headersList = [
        "Paid",
        "Unpaid",
        "Refund",
        "Camp",
        "Start Date",
        "End Date"
      ];
      this.headers = TableHeaders(headersList);
    },
    handlePagination(page) {
      const queries = { ...this.$route.query, page };
      if (!isEqual(queries, this.$route.query)) {
        this.$router.push({ query: queries });
      }
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.indexReservation(query);
        this.pagination.current_page = query.page;
        this.filter.type = query.type;
        this.filter.date = query.date;
        this.filter.location = query.location;
        this.filter.available = query.available;
        this.date = query.date;
      },
      immediate: true
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    }
  }
};
</script>
<style lang="scss" scoped>
// .filter-area {
//   padding-top: 0 !important;
//   background-color: white !important;
//   .col-sm-8 {
//     padding: 0 !important;
//   }
// }
</style>
